import _ from 'underscore';
import * as d3 from 'd3';
import Mustache from 'mustache'
import accounting from 'accounting';

import './css/all.less';
import cegepsJson from './data/cegeps.json'
import fichesJson from './data/fiches.json'
import regionsJson from './data/regions.json'
import utils from './js/utils.js'

init();

function init() {
  // Mash data
  let features = _
    .chain(fichesJson)
    .map((d) => {
      let found = _.find(cegepsJson, (dd) => {
        return dd.nom + ", " + dd.ville == d.nom;
      });
      let props = _.extend(d,_.omit(found,"region"));
      props.id = found.id;
      let foundRegion = _.find(regionsJson, (dd) => {
        return dd.nom == d.région;
      });
      if (foundRegion){
        props.id_region = foundRegion.id;
      }
      props.weight = props.etud;
      let coords = props.latitude_longitude.split(",").reverse().map(parseFloat);
      let geom = {
        type: "Point",
        coordinates: coords
      };
      return {
        "type": "Feature",
        "properties": props,
        "geometry": geom
      };
    })
    .sortBy((d) => { return d.properties.id_region; })
    .value();

  let geodata = {
    "type": "FeatureCollection",
    "features": features
  };

  // Show the map?
  if (! d3.select("#carte-cegeps").empty() && !window.hasCarteCegeps) {
    initMap("carte-cegeps", geodata);
    window.hasCarteCegeps = true;
  }
  
  // Show the list?
  if (! d3.select("#liste-cegeps").empty() && !window.hasListeCegeps) {
    initList("liste-cegeps", geodata);
    window.hasListeCegeps = true;
  }
}

function initMap(id, geodata) {
  mapboxgl.accessToken = 'pk.eyJ1IjoiaW5mb2pkZW0iLCJhIjoiY2lnamxhNmsxMDA0cXQ2bHU2em94eTdycCJ9.6DF-qtbVm_5LPbWLaTaQ4A';
  let map = new mapboxgl.Map({
    container: id,
    // style:"mapbox://styles/infojdem/ck2qd7gu22gtw1ctcsyeq69wg",
    style: "mapbox://styles/infojdem/ck6lkk3qt0aud1iqmlhm86mrh",
    center: [-71.8721, 48.1427],
    zoom:  5.1,
    pitch: 0,
    bearing: 0,
    attributionControl: false,
  });

  if (mapWidth() < 641) {
    map.setZoom(3.3);
  }

  map.addControl(new mapboxgl.NavigationControl({ showCompass:false }));
  map.addControl(new mapboxgl.FullscreenControl());

  function mapWidth() {
    return map.getContainer().getBoundingClientRect().width;
  }

  map.on('load', function() {
    map.addSource("data", {
      type: "geojson",
      data: geodata,
    });

    map.addLayer({
      "id": "circles",
      "type": "circle",
      "source": "data",
      "minzoom": 3,
      "paint": {
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          3, [
            "interpolate",
            ["linear"],
            ["get", "weight"],
            625, 3,
           1250, 3,
           2500, 4,
           5000, 4
          ],
          5, [
            "interpolate",
            ["linear"],
            ["get", "weight"],
             625, 3,
            1250, 3,
            2500, 4,
            5000, 4
          ],
          9, [
            "interpolate",
            ["linear"],
            ["get", "weight"],
             625, 3,
            1250, 3,
            2500, 4,
            5000, 4
          ],
          11, [
            "interpolate",
            ["linear"],
            ["get", "weight"],
            625,  4,
           1250,  8,
           2500, 12,
           5000, 16
          ],
        ],
        "circle-color": [
          "case",
          ["==", ["get", "région"], "Abitibi-Témiscamingue"],  "#D3D4D0",
          ["==", ["get", "région"], "Bas-Saint-Laurent"],  "#e4bd95",
          ["==", ["get", "région"], "Capitale-Nationale"],  "#75d0f0",
          ["==", ["get", "région"], "Centre-du-Québec"],  "#98e0c9",
          ["==", ["get", "région"], "Chaudière-Appalaches"],  "#E5E5E5",
          ["==", ["get", "région"], "Côte-Nord"],  "#b0c4d6",
          ["==", ["get", "région"], "Estrie"],  "#ff6f6f",
          ["==", ["get", "région"], "Gaspésie-Îles-de-la-Madeleine"],  "#98c2f5",
          ["==", ["get", "région"], "Lanaudière"],  "#f9b1b1",
          ["==", ["get", "région"], "Laurentides"],  "#c0afd7",
          ["==", ["get", "région"], "Laval"],  "#d7baaf",
          ["==", ["get", "région"], "Mauricie"],  "#BECCF1",
          ["==", ["get", "région"], "Montérégie"],  "#bed7af",
          ["==", ["get", "région"], "Montréal"],  "#a3e6e6",
          ["==", ["get", "région"], "Outaouais"],  "#b6b3d4",
          ["==", ["get", "région"], "Saguenay-Lac-Saint-Jean"],  "#d8abc8",
          "#000000"
        ],
        "circle-stroke-width": [
          "interpolate", ["linear"], ["zoom"],
          3.0, 0,
          3.1, 1.5,
          8.0, 2
        ],
        "circle-stroke-color": "#333"
      }
    // }, 'road-label');
    });

    map.addLayer({
      "id": "names",
      "type": "symbol",
      "source": "data",
      "paint": {
        "text-color": "#ffffff",
        'text-halo-color': 'rgba(0,0,0,1)',
        'text-halo-width': 2,
        "text-opacity": [
          "interpolate",
          ["linear"],
          ["zoom"],
           7.9, 0,
           8.0, 1
        ]
      },
      "layout": {
        "text-field": ["get", "nom"],
        "text-variable-anchor": ["top", "bottom", "left", "right"],
        "text-radial-offset": 1.0,
        "text-justify": "auto",
        "icon-image": ["concat", ["get", "icon"], "-15"],
      }
    });
    
    // For devs only. Disable before deployment.
    map.on("move", function(e){
      //console.log("C:" + map.getCenter() + " Z:" + map.getZoom() + " P:" + map.getPitch() + " B:" + map.getBearing());
    });
    
    // Change the cursor to a pointer when the mouse is over labels and markers.
    // map.on('mouseenter', 'labels', pointerOn);
    map.on('mouseenter', 'circles', pointerOn);
     
    // Change it back to a pointer when it leaves.
    // map.on('mouseleave', 'labels', pointerOff);
    map.on('mouseleave', 'circles', pointerOff);

    // When a click event occurs on a feature in the places layer, open a popup at the
    // location of the feature, with description HTML from its properties.
    // map.on('click', 'labels', showInfo);
    map.on('click', 'circles', showInfo);

    // Helpers
    function pointerOn() {
      map.getCanvas().style.cursor = 'pointer';
    }
    
    function pointerOff() {
      map.getCanvas().style.cursor = '';
    }
    
    function showInfo(e) {
      let coordinates = e.features[0].geometry.coordinates.slice();
      let head = renderCardHead(e.features[0]);
      let body = renderCardBody(e.features[0]);
      let region = e.features[0].properties.region.toLowerCase();
      let info =
      `<div class="card card--expanded ${region}">
        <div>${head}</div>
        <div>${body}</div>
      </div>`;
      // Ensure that if the map is zoomed out such that multiple
      // copies of the feature are visible, the popup appears
      // over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      let isFullscreen = mapWidth() < 641;

      if (isFullscreen) {
        let ol = d3.select(".overlay");
        let con = d3.select(".overlay__content");
        let btn = d3.select(".overlay__close-btn");

        ol.classed("overlay--active", true);
        con.html(info);
        btn.on("click", () => { ol.classed("overlay--active", false); });
      }
      else {
        let popup = new mapboxgl.Popup({ closeButton:false })
          .setLngLat(coordinates)
          .setHTML(info)
          .addTo(map);

        let mR = map.getContainer().getBoundingClientRect(),
            pR = popup._container.getBoundingClientRect();
        
        console.log(mR);
        console.log(pR);

        if (pR.y < mR.y || pR.bottom > mR.bottom) {

          let isInMiddle = pR.y > (mR.y + mR.height/3) && pR.y < (mR.y + mR.height*2/3),
              isClosestToTop = pR.y < (mR.y + mR.height/4),
              isClosestToBottom = !isClosestToTop,
              isTopAnchor = (document.querySelector(".mapboxgl-popup-anchor-top") !== null ||
                             document.querySelector(".mapboxgl-popup-anchor-top-right") !== null ||
                             document.querySelector(".mapboxgl-popup-anchor-top-left") !== null),
              dy = 0;

          console.log(isInMiddle);
          console.log(isClosestToTop);
          console.log(isClosestToBottom);
          console.log(isTopAnchor);

          if (isTopAnchor && isClosestToBottom) {
            let el = document.querySelector(".mapboxgl-popup");
            dy = (pR.y+pR.height) - (mR.y+mR.height-50);
            console.log(dy);
          }

          popup._container.classList.add("hidden");
          map.panBy([0,dy], {easing:easingFn});
          map.once("moveend", function(d){
            popup._container.classList.remove("hidden");
          })
        }
      }
    }

    function easingFn(t) {
      return t * (2 - t);
    }
  });
}

function initList(id, geodata) {
  let div = d3.select(`#${id}`);

  let card = div.selectAll(".card")
    .data(geodata.features, (d) => { return d.properties.id; })
    .enter()
      .append("div")
        .attr("class", (d) => { return `card ${d.properties.région.toLowerCase()}`; })
        .attr("id", (d) => { return `card-${d.properties.id}`; });

  card.append("div")
    .html(function(d){ return renderCardHead(d); });

  card.append("div")
    .attr("class", "toggle")
    .append("span")
      .attr("class", "fa fas fa-chevron-circle-down");

  card.append("div")
    .html(function(d){ return renderCardBody(d); });

  card.select(".toggle").select("span").on("click", function() {
    let sel = d3.select(`#card-${d3.select(this).datum().properties.id}`);
    let flag = sel.classed("card--expanded");
    sel.classed("card--expanded", !flag);
  });
}

function renderCardHead(d){
  let templ = "\
    <div class='card__head'>\
      <div><p class='region'>{{region}}</p></div>\
      <div>\
        <p class='name'>{{name}}</p>\
        <p class='address'>{{address}}</p>\
        <p class='city'>{{city}}</p>\
      </div>\
      <div class='legend'>\
        <ul>\
          <li><span class='fa fas fa-users'></span> {{etud}}</li>\
          <li><span class='fa far fa-list-alt'></span> {{msec}}</li>\
          <li><span class='fa fas fa-user-friends'></span> {{hand}}</li>\
        </ul>\
      </div>\
    </div>";

  let props = d.properties;

  let data = {
    region: props.region,
    name: props.nom,
    address: props.adresse,
    city: props.ville + ", " + props.code_postal,
    etud: formatNumber(props.etud,0),
    msec: formatNumber(props.msec,1)+"%",
    hand: formatNumber(props.hand_pc,1)+"%"
  };

  return Mustache.render(templ,data).trim();
}

function renderCardBody(d){
  let templ = "\
    <div class='card__body'>\
      <div class='legend'>\
        <p>Taux de diplomation et classements par programmes répertoriés</p>\
      </div>\
      <table>\
        <thead>\
          <tr>\
            <th>Technique</th>\
            <th>Diplomation</th>\
            <th>Rang</th>\
          <tr>\
        </thead>\
        <tbody>\
          {{#snat_pc}}\
            <tr>\
              <td>Sciences de la nature</td>\
              <td>{{snat_pc}} {{{snat_as}}}</td>\
              <td>{{snat_rg}}</td>\
            </tr>\
          {{/snat_pc}}\
          {{#shum_pc}}\
          <tr>\
            <td>Sciences humaines</td>\
            <td>{{shum_pc}} {{{shum_as}}}</td>\
            <td>{{shum_rg}}</td>\
          </tr>\
          {{/shum_pc}}\
          {{#arts_pc}}\
          <tr>\
            <td>Arts, lettres et communication</td>\
            <td>{{arts_pc}} {{{arts_as}}}</td>\
            <td>{{arts_rg}}</td>\
          </tr>\
          {{/arts_pc}}\
          {{#tsoi_pc}}\
          <tr>\
            <td>Technique en soins infirmiers</td>\
            <td>{{tsoi_pc}} {{{tsoi_as}}}</td>\
            <td>{{tsoi_rg}}</td>\
          </tr>\
          {{/tsoi_pc}}\
          {{#tcom_pc}}\
          <tr>\
            <td>Technique de comptabilité et de gestion</td>\
            <td>{{tcom_pc}} {{{tcom_as}}}</td>\
            <td>{{tcom_rg}}</td>\
          </tr>\
          {{/tcom_pc}}\
          {{#tinf_pc}}\
          <tr>\
            <td>Technique de l'informatique</td>\
            <td>{{tinf_pc}} {{{tinf_as}}}</td>\
            <td>{{tinf_rg}}</td>\
          </tr>\
          {{/tinf_pc}}\
          {{#tges_pc}}\
          <tr>\
            <td>Technique en gestion de commerces</td>\
            <td>{{tges_pc}} {{{tges_as}}}</td>\
            <td>{{tges_rg}}</td>\
          </tr>\
          {{/tges_pc}}\
          {{#tedu_pc}}\
          <tr>\
            <td>Technique d'éducation spécialisée</td>\
            <td>{{tedu_pc}} {{{tedu_as}}}</td>\
            <td>{{tedu_rg}}</td>\
          </tr>\
          {{/tedu_pc}}\
          {{#tede_pc}}\
          <tr>\
            <td>Technique d'éducation à l'enfance</td>\
            <td>{{tede_pc}} {{{tede_as}}}</td>\
            <td>{{tede_rg}}</td>\
          </tr>\
          {{/tede_pc}}\
          {{#tgen_pc}}\
          <tr>\
            <td>Technique de génie mécanique</td>\
            <td>{{tgen_pc}} {{{tgen_as}}}</td>\
            <td>{{tgen_rg}}</td>\
          </tr>\
          {{/tgen_pc}}\
          {{#ttra_pc}}\
          <tr>\
            <td>Technique de travail social</td>\
            <td>{{ttra_pc}} {{{ttra_as}}}</td>\
            <td>{{ttra_rg}}</td>\
          </tr>\
          {{/ttra_pc}}\
          {{#tgec_pc}}\
          <tr>\
            <td>Technique du génie civil</td>\
            <td>{{tgec_pc}} {{{tgec_as}}}</td>\
            <td>{{tgec_rg}}</td>\
          </tr>\
          {{/tgec_pc}}\
          {{#tpol_pc}}\
          <tr>\
            <td>Techniques policières</td>\
            <td>{{tpol_pc}} {{{tpol_as}}}</td>\
            <td>{{tpol_rg}}</td>\
          </tr>\
          {{/tpol_pc}}\
        </tbody>\
      </table>\
    </div>";

  let props = d.properties;

  let data = {
    snat_pc: formatIfPercent(props.snat_pc,1),
    snat_rg: props.snat_rg,
    snat_as: precisionWarningIf(props.snat_warn),

    shum_pc: formatIfPercent(props.shum_pc,1),
    shum_rg: props.shum_rg,
    shum_as: precisionWarningIf(props.shum_warn),

    arts_pc: formatIfPercent(props.arts_pc,1),
    arts_rg: props.arts_rg,
    arts_as: precisionWarningIf(props.arts_warn),

    tsoi_pc: formatIfPercent(props.tsoi_pc,1),
    tsoi_rg: props.tsoi_rg,
    tsoi_as: precisionWarningIf(props.tsoi_warn),

    tcom_pc: formatIfPercent(props.tcom_pc,1),
    tcom_rg: props.tcom_rg,
    tcom_as: precisionWarningIf(props.tcom_warn),

    tinf_pc: formatIfPercent(props.tinf_pc,1),
    tinf_rg: props.tinf_rg,
    tinf_as: precisionWarningIf(props.tinf_warn),

    tges_pc: formatIfPercent(props.tges_pc,1),
    tges_rg: props.tges_rg,
    tges_as: precisionWarningIf(props.tges_warn),

    tedu_pc: formatIfPercent(props.tedu_pc,1),
    tedu_rg: props.tedu_rg,
    tedu_as: precisionWarningIf(props.tedu_warn),

    tede_pc: formatIfPercent(props.tede_pc,1),
    tede_rg: props.tede_rg,
    tede_as: precisionWarningIf(props.tede_warn),

    tgen_pc: formatIfPercent(props.tgen_pc,1),
    tgen_rg: props.tgen_rg,
    tgen_as: precisionWarningIf(props.tgen_warn),

    ttra_pc: formatIfPercent(props.ttra_pc,1),
    ttra_rg: props.ttra_rg,
    ttra_as: precisionWarningIf(props.ttra_warn),

    tgec_pc: formatIfPercent(props.tgec_pc,1),
    tgec_rg: props.tgec_rg,
    tgec_as: precisionWarningIf(props.tgec_warn),

    tpol_pc: formatIfPercent(props.tpol_pc,1),
    tpol_rg: props.tpol_rg,
    tpol_as: precisionWarningIf(props.tpol__warn)
  };

  return Mustache.render(templ,data).trim();
}

function formatIfNumber(n, decimals){
  return isFinite(n) ? formatNumber(n, decimals) : n;
}

function formatIfPercent(n, decimals){
  return isFinite(n) ? formatNumber(n, decimals) + "%" : n;
}

function formatIfMoney(n){
  return isFinite(n) ? formatMoney(n, 2) : n;
}

function formatNumber(n, decimals) {
  if (n === "" || n === null){
    return "-"
  }
  else {
    return isFinite(n) ? accounting.formatNumber(n, {precision:decimals, format:"%v %s", decimal:",", thousand:" "}) : "ND";
  }
}

function formatMoney(val, decimals) {
  return isFinite(val) ? accounting.formatMoney(val, {precision:decimals,format:"%v %s",thousand:" "}) : "ND";
}

function precisionWarningIf(f) {
  if (f) {
    return "<sup><span class='fas fa-asterisk fa-xs'></span></sup>";
  }
  return "";
}